import { LocalStorage } from 'utils';

const SNOW_ENABLED_KEY = 'ui.snow.enabled';
const SNOW_COLOR_KEY = 'ui.snow.color';

export type SnowColorOption = {
  id: string;
  labelId: string;
  rgba: string;
};

export const SNOW_COLORS: SnowColorOption[] = [
  { id: 'idecon', labelId: 'snow.color.idecon', rgba: 'rgb(60,171,225)' },
  { id: 'classic', labelId: 'snow.color.classic', rgba: 'rgba(255,255,255,0.95)' },
  { id: 'ice', labelId: 'snow.color.ice', rgba: 'rgba(180,220,255,0.95)' },
  { id: 'gold', labelId: 'snow.color.gold', rgba: 'rgba(255,215,120,0.95)' },
  { id: 'mint', labelId: 'snow.color.mint', rgba: 'rgba(180,255,220,0.95)' },
  { id: 'pink', labelId: 'snow.color.pink', rgba: 'rgba(255,180,220,0.95)' },
  { id: 'purple', labelId: 'snow.color.purple', rgba: 'rgba(210,180,255,0.95)' },
  { id: 'warm', labelId: 'snow.color.warm', rgba: 'rgba(255,245,220,0.95)' },
];

export const getSnowEnabled = (): boolean => {
  const raw = LocalStorage.getItem(SNOW_ENABLED_KEY);

  if (raw == null) return true;
  return raw === '1';
};

export const setSnowEnabled = (v: boolean) => {
  LocalStorage.setItem(SNOW_ENABLED_KEY, v ? '1' : '0');
};

export const getSnowColorId = (): string => {
  return LocalStorage.getItem(SNOW_COLOR_KEY) || 'idecon';
};

export const setSnowColorId = (id: string) => {
  LocalStorage.setItem(SNOW_COLOR_KEY, id);
};

export const resolveSnowColor = (id?: string): string => {
  return SNOW_COLORS.find((x) => x.id === id)?.rgba ?? SNOW_COLORS[0].rgba;
};
